/**
 *
 * @param {Function} callback
 * @param {Number} delay
 * @returns {(function(): void)|*}
 */
function throttle(callback, delay) {
    let timeout = null;

    /* eslint-disable-next-line space-before-function-paren */
    return function () {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            callback.apply(this, arguments);
        }, delay);
    };
}

/**
 *
 * @param {HTMLSelectElement} target
 */
function resetTarget(target) {
    const initialOptions = target.querySelectorAll('option');

    for (const option of initialOptions) {
        if (option.value || option.disabled === false) {
            option.remove();
        } else {
            option.selected = true;
        }
    }
}

/**
 *
 * @param {string[]} realEstates
 * @param {HTMLSelectElement} target
 */
function setRealEstatesToTarget(realEstates, target) {
    resetTarget(target);

    for (const realty of realEstates) {
        const option = document.createElement('option');

        option.setAttribute('value', realty);
        option.innerText = realty;

        target.append(option);
    }
}

/**
 *
 * @param {HTMLSelectElement} target
 */
function handleError(target) {
    resetTarget(target);

    // TODO?
}

async function onInput(value, target) {
    try {
        const response = await fetch(`${CONFIG.misc.realEstatesEndpoint}?address=${encodeURIComponent(value)}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (response.ok) {
            const result = await response.json();

            if (result.success) {
                if (!Array.isArray(result.data)) {
                    throw new Error();
                }

                const sanitizedData = result.data.filter((item) => typeof item === 'string');

                if (result.data.length !== sanitizedData.length) {
                    throw new Error();
                }

                setRealEstatesToTarget(sanitizedData, target);
            } else {
                throw new Error();
            }
        } else {
            throw new Error();
        }
    } catch (e) {
        handleError(target);
    }
}

/**
 * @param {HTMLInputElement} source
 * @param {HTMLSelectElement} target
 *
 * @private
 */
export function initRealEstates(source, target) {
    source.addEventListener(
        'input',
        throttle((event) => {
            onInput(event.target.value, target);
        }, 300),
    );

    if (source.value) {
        onInput(source.value, target);
    }
}
